import { render, staticRenderFns } from "./achievementDetails.vue?vue&type=template&id=2eef2732&scoped=true"
import script from "./achievementDetails.vue?vue&type=script&lang=js"
export * from "./achievementDetails.vue?vue&type=script&lang=js"
import style0 from "./achievementDetails.vue?vue&type=style&index=0&id=2eef2732&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eef2732",
  null
  
)

export default component.exports